/**
 * @fileoverview A carousel that fades on swipe
 *
 * @author Kaleb White
 */

// See comment in `src/css/styles.scss` for why the css isn't imported here.

import $ from 'jquery';
import OdoFadeCarousel from 'js/odo-carousel-fade';

class SwipeCarousel {
  constructor() {
    /**
     * Base element for the swipe carousel component.
     * @type {jQuery|Object}
     * @private
     */
    this.element = $('.swipe-carousel');

    /**
     * The base swipe carousel.
     * @type {jQuery|Object}
     * @private
     */
    this._swipeCarousel = null;

    this.initializeAll();
  }

  initializeAll() {
    this._swipeCarousel = this.element.find('.spark-carousel--fade');

    this._initializeCarousel();

    this._initializeSwipeFunctionality();
  }

  _initializeCarousel() {
    return this._swipeCarousel.map((i, el) => new OdoFadeCarousel(el, {})).get();
  }

  _initializeSwipeFunctionality() {
  }

  dispose() {
    this.element = null;
  }
}

export default new SwipeCarousel();
